module.exports = __webpack_public_path__ + "static/media/personal-info.8745b442.svg";